import React, { useCallback, useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import AttributeOwners from "./AttributeOwners";
import MarketListings from "./MarketListings";
import SalesVolume from "./SalesVolume";
import attributeStyles from "./scss/attributes.module.scss";

const Attributes = () => {
  const [key, setKey] = useState("salesVolume");
  return (
    <main className="float-top position-relative">
      <section>
        <div className="container">
          <div className={attributeStyles.siteTable}>
            <div className="header-before">
              <div className={`${attributeStyles.tbaleHead}`}>
                {/* <h3>{title}</h3> */}
              </div>
              <div className="chart-box bg-white">
                {/* <div className="d-flex justify-content-between align-items-center"> */}
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey={key}
                  transition={true}
                  onSelect={(k) => {
                    setKey(k);
                  }}
                  unmountOnExit={true}
                >
                  {/* <div className="tab-btn-group2 pb">
                      <div className="d-flex w-100 justify-content-between align-items-center"> */}
                  <Nav>
                    <Nav.Item>
                      <Nav.Link eventKey="salesVolume" className="tab-btn mb-5">
                        Sales Volume
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="attributeOwners" className="tab-btn">
                        Attributes Owners
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="marketListings" className="tab-btn">
                        Market Listings
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  {/* </div>
                    </div> */}
                  <Tab.Content>
                    <Tab.Pane eventKey="salesVolume">
                      <SalesVolume />
                    </Tab.Pane>
                    <Tab.Pane eventKey="attributeOwners">
                      <AttributeOwners />
                    </Tab.Pane>
                    <Tab.Pane eventKey="marketListings">
                      <MarketListings />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Attributes;
